import LeaderboardSvg from './LeaderboardSvg.jsx';

export default LeaderboardSvg;